export default __webpack_public_path__ + "static/media/plus.3b867d82.svg";